import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import styles from "./TermsDialog.module.scss";
import ClearIcon from "@mui/icons-material/Clear";
import withStyles from '@mui/styles/withStyles';
import { withTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import FileBrowser from "../fileBrowser/FileBrowser";
import pdfIcon from "../../imgs/pdf-acrobat-icon.svg";
import Grid from "@mui/material/Grid";

const StyledClearIcon = withStyles({
  root: {
    color: "#102b4e",
  },
})(ClearIcon);

const StyledDialog = withStyles({
  paper: {
    maxWidth: 600,
    width: 750,
  },
})(Dialog);

const StyledClose = withStyles({
  root: {
    color: "#102b4e",
  },
})(ClearIcon);

function TermsDialog(props) {
  const [file, setFile] = useState(null);
  const [fileUploaded, setFileUploaded] = useState(false);
  const [warningMsg, setWarningMsg] = useState(false);
  const [overSizeErr, setOverSizeErr] = useState(false);

  function onClose() {
    removeFile();
    props.onClose();
  }

  function onFileSelected(file) {
    if (file.type === "application/pdf") {
      if (file.size > 1000000) {
        setOverSizeErr(true);
      } else {
        setFile(file);
        setFileUploaded(true);
      }
    } else {
      setWarningMsg(true);
    }
  }

  function getAppliedList() {
    return (
      props.contracts &&
      props.contracts.filter((contract) => contract.contract !== null)
    );
  }

  function getPendingList() {
    return (
      props.contracts &&
      props.contracts.filter((contract) => contract.contract === null)
    );
  }

  function applyToDealer() {
    sendFileToSave(props.currentDealerId);
  }

  function applyToAll() {
    let dealerIds = [];
    props.contracts.forEach((contract) => {
      dealerIds = [...dealerIds, contract.dealerId];
    });
    sendFileToSave(dealerIds);
  }

  function applyToBranches() {
    let dealerIds = [];
    getPendingList().forEach((contract) => {
      dealerIds = [...dealerIds, contract.dealerId];
    });
    sendFileToSave(dealerIds);
  }

  function sendFileToSave(dealerIds) {
    const currentFile = file;
    removeFile();
    props.confirmAction(dealerIds, currentFile);
  }

  function removeFile() {
    setFile(null);
    setFileUploaded(false);
    setWarningMsg(false);
  }

  function showList(list) {
    return list.length > 0;
  }

  return (
    <StyledDialog open={props.open} onClose={onClose}>
      <div className={styles.dialogBody}>
        <div className={styles.cancelButton}>
          <button
            data-testid="closeDialogBtn"
            className={styles.closeDialogBtn}
            onClick={onClose}
            type="submit"
          >
            <StyledClose />
          </button>
        </div>
        <div className={styles.dialogHeader}>{props.dialogTitle}</div>
        <div className={styles.dialogDescription}>
          {props.dialogBody}
        </div>
        {fileUploaded ? (
          <>
            <div className={styles.dialogPadding}>
              <div className={styles.fileNameTextBox}>
                <div>
                  <img src={pdfIcon} />
                  <p className={styles.fileName}>{file.name}</p>
                </div>
                <div
                  className={styles.clearImage}
                  id="removeFile"
                  onClick={removeFile}
                >
                  <StyledClearIcon />
                </div>
              </div>
            </div>
            {props.forAll ? (
              showList(getPendingList()) &&
              showList(getAppliedList()) ? (
                <>
                  <div className={styles.dialogPadding}>
                    <div className={styles.dialogSubHeader}>
                      {props.t("dealerTermsDialog.overViewApplied")}
                    </div>
                    <div className={styles.dialogBox}>
                      <Grid container>
                        {getAppliedList().map((contract) => {
                          return (
                            <Grid
                              item
                              md={6}
                              key={contract.dealerId}
                              className={styles.dialogDealerName}
                            >
                              {contract.name}
                            </Grid>
                          );
                        })}
                      </Grid>
                    </div>
                    <div className={styles.dialogSubHeader}>
                      {props.t("dealerTermsDialog.overViewNotApplied")}
                    </div>
                    <div className={styles.dialogBox}>
                      <Grid container>
                        {getPendingList().map((contract) => {
                          return (
                            <Grid
                              item
                              md={6}
                              key={contract.dealerId}
                              className={styles.dialogDealerName}
                            >
                              {contract.name}
                            </Grid>
                          );
                        })}
                      </Grid>
                    </div>
                  </div>
                  <div className={styles.cancelBtnDiv} onClick={onClose}>
                    <Button className={styles.closeBtn}>
                      <span> {props.t("dealerTermsDialog.cancel")}</span>
                    </Button>
                  </div>
                  <div
                    className={styles.applyBranchBtnDiv}
                    onClick={applyToBranches}
                  >
                    <Button className={styles.actionBtn}>
                      <span>
                        {props.t("dealerTermsDialog.applyToBranches")}
                      </span>
                    </Button>
                  </div>
                  <div
                    className={styles.applyAllBtnDiv}
                    onClick={applyToAll}
                  >
                    <Button className={styles.actionBtn}>
                      <span>
                        {props.t("dealerTermsDialog.applyToAll")}
                      </span>
                    </Button>
                  </div>
                </>
              ) : (
                <div className={styles.applyBtnDiv} onClick={applyToAll}>
                  <Button className={styles.actionBtn}>
                    <span>
                      {props.t("dealerTermsDialog.applyToAll")}
                    </span>
                  </Button>
                </div>
              )
            ) : (
              <div
                className={styles.applyBtnDiv}
                onClick={applyToDealer}
              >
                <Button className={styles.actionBtn}>
                  <span>{props.saveText}</span>
                </Button>
              </div>
            )}
          </>
        ) : (
          <>
            <div className={styles.dialogPadding}>
              <FileBrowser
                fileType=".pdf"
                onFileSelected={onFileSelected}
                data-testId="pdf-file"
                id="pdf-file"
              >
                <Button className={styles.uploadBtn} component="span">
                  {props.t(
                    "dealerTermsDialog.uploadNewTermsAndConditions"
                  )}
                </Button>
              </FileBrowser>
            </div>
            {overSizeErr ? (
              <div className={styles.warningMessage}>
                {props.t("dealerTermsDialog.bigFile")}
              </div>
            ) : warningMsg ? (
              <div className={styles.warningMessage}>
                {props.t("dealerTermsDialog.wrongFile")}
              </div>
            ) : (
              <div className={styles.fileTypeDesc}>
                {props.t("dealerTermsDialog.fileType")}
              </div>
            )}
            <div className={styles.actionBtnDiv}>
              <Button disabled className={styles.disableActionBtn}>
                <span className={styles.closeText}>
                  {props.saveText}
                </span>
              </Button>
            </div>
          </>
        )}
      </div>
    </StyledDialog>
  );
}

export default withTranslation("emp")(TermsDialog);
